import { SafeResourceUrl } from '@angular/platform-browser';
import {
    IPathAndDash,
    IStagePositionsExtended,
    IStagePositionWithConfigs,
    IVideoThumbnails,
    MimeTypeEnum,
} from 'src/app/models/defines';
import { TakeRecorderManager } from '../../controllers/take-recorder.manager';
import { ITakeContext } from '../take-model';
import { ILocalWithIsDisabled } from '../../../../pages/private/dashboard/project/shared-components/video-layer-setup/video-layer-setup.component';

export interface IDisplayedVideoLayerButtons {
    toDisplayFlip: boolean;
    toDisplayRemoveAsset: boolean;
    toDisplayChangeAsset: boolean;
    toDisplayStrategy: boolean;
    isMasterSettings: boolean;
    toDisplayUseSubtitles: boolean;
    toDisplaySelectStagePositions: boolean;
    toDisplayTrim: boolean;
    toDisplaySoundSettings: boolean;
}
export enum VideoLayerPlaybackStrategyEnum {
    LAST_FRAME_FREEZE = 'last_frame_freeze',
    LOOP_VIDEO = 'loop_video',
}
export enum VideoLayerTypeEnum {
    CAMERA = 'camera',
    MIC = 'mic',
    AI_VOICE = 'ai-voice',
    AVATAR = 'avatar',
    ASSET = 'asset',
}
export interface IBasicVideoLayer extends IPathAndDash {
    id: string;
    videoPosition: IStagePositionsExtended;
    defaultTrimStart?: number;
    defaultTrimEnd?: number;
    width: number;
    height: number;
    videoThumbnails?: IVideoThumbnails[];
    toFlip: boolean;
    isMaster: boolean;
    playbackStrategy: VideoLayerPlaybackStrategyEnum;
    duration?: number;
}

export interface IVideoLayerInDTO extends IBasicVideoLayer, IPathAndDash {
    uploadPath?: string;
    type: VideoLayerTypeEnum;
    isMuted: boolean;
    toUseSubtitles: boolean;
}

export interface IVideoLayerOutDTO extends IBasicVideoLayer {}

export interface IVideoAndMime {
    url: string;
    type: MimeTypeEnum;
}
export interface IVideoLayer extends IVideoLayerInDTO {
    uinuqeId: string;
    storeManagerId: string; /// for indexdb
    localUrlConfigs?: IVideoAndMime;
}
export interface IVideoLayerContext extends ITakeContext {
    videoLayerId: string;
}

export interface IPlaybackStrategiesWrapper {
    toDisplay: boolean;
    values: ILocalWithIsDisabled<VideoLayerPlaybackStrategyEnum>[];
}
export interface ISettingWrapper<T> {
    toDisplay: boolean;
    value: ILocalWithIsDisabled<T>;
}

export interface IVLSettings {
    availableStagePositions: IStagePositionWithConfigs[];
    playbackStrategies: IPlaybackStrategiesWrapper;
    isMaster: ISettingWrapper<boolean>;
    toFlip: boolean;
    toUseSubtitles: ISettingWrapper<boolean>;
    toTrim: boolean;
}
export interface IVLWithSettings extends IVideoLayer {
    settingsToHaveInMenu: IVLSettings;
}
